import * as React from "react";
function SvgBookmark(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeWidth={2}
        stroke="currentColor"
        d="M5 1h22v28L16 18 5 29V1z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgBookmark);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
